import { render } from "./HeroSign.vue?vue&type=template&id=8c3baf8c&scoped=true"
import script from "./HeroSign.vue?vue&type=script&lang=js"
export * from "./HeroSign.vue?vue&type=script&lang=js"

import "./HeroSign.vue?vue&type=style&index=0&id=8c3baf8c&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-8c3baf8c"

export default script